import * as React from 'react';
import { RegionsModal } from '../../components/RegionsModal';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentRegion, selectRegionsABC } from '../../selectors/region';
import { selectPrimalRegions } from '../../selectors/region/selectPrimalRegions';
import { setCurrentRegion } from '../../actions/region';
import { IRegion } from '../../types/region';
import { setRegion } from '../../actions/filters';
import { fetchBuildersInfo } from '../../actions/buildersInfo';
import { TThunkDispatch } from '../../types/redux';

export interface IRegionsModalContainerProps {
  open: boolean;
  onClose: () => void;
}

export function RegionsModalContainer(props: IRegionsModalContainerProps): React.JSX.Element {
  const { open, onClose } = props;
  const currentRegion = useSelector(selectCurrentRegion);
  const regions = useSelector(selectRegionsABC);
  const primalRegions = useSelector(selectPrimalRegions);
  const dispatch: TThunkDispatch = useDispatch();

  const handleSubmit = React.useCallback(
    (region: IRegion) => {
      dispatch(setCurrentRegion(region));
      dispatch(setRegion(region.id));
      dispatch(fetchBuildersInfo());
    },
    [dispatch],
  );

  return (
    <RegionsModal
      currentRegion={currentRegion}
      primalRegions={primalRegions}
      regions={regions}
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  );
}
